import { render, staticRenderFns } from "./UpdateAutoMatchDetails.vue?vue&type=template&id=21d5f0b8&"
import script from "./UpdateAutoMatchDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateAutoMatchDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAutoMatchDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports